import React, { Component } from "react";
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import { Table, Button } from 'react-bootstrap';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import { lookupsNotRender } from "../../libs/services";
import LabelForm from "../../components/LabelForm";
import SelectForm from "../../components/SelectForm";
import InputMaskForm from "../../components/InputMaskForm";
import InputForm from "../../components/InputForm";
import PlusButton from "../../components/PlusButton";
import IconButton from "../../components/IconButton";


class PhonesData extends Component {
	constructor(props) {
		super(props);
		
		this.addPhone = this.addPhone.bind(this);
		this.removePhone = this.removePhone.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.state = {
			phonesAdded:[],
			phoneTypes:[],
			phone_type:"CELULAR",
			phone_number:"",
			ext:"",

			showCheckboxes: false,
			

			
			errorText_phone_type:"",
			errorText_phone_number:"",
		};
	}

	async componentDidMount() {
		this.props.onRef(this);
		var response = await lookupsNotRender('PHONE_TYPE');
		if(response){
			var options = response.map((res)=>{
				var obj = {
					value: res.key,
					text: res.name
				}
				return obj;
			});

			this.setState({phoneTypes: options});
		}
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value });

		if(e.target.name === 'phone_type'){
			this.setState({ext:''});
		}
	}

	addPhone() {
		if (this.isValidForm()) {
			var index = this.state.phonesAdded.findIndex(obj => obj.type === this.state.phone_type);
			var phones = this.state.phonesAdded;
			if(index === -1){
				var obj = {
					type: this.state.phone_type,
					number: this.state.phone_number,
					extension: this.state.ext
				}

				phones.push(obj);
			  	
			  	this.setState({phone_number:"", phonesAdded: phones, ext:''});
			}else{
				swal('¡El teléfono no se puede agregar!', '¡Ya se ingreso un número con ese tipo!', 'error');
			}
		} else{
		  swal('¡El teléfono no se puede agregar, tiene errores de validación!', '¡Los errores están marcados en rojo!', 'error');
		};
	}

	removePhone(indice){
		var array = this.state.phonesAdded;
		array.splice(indice, 1);
		this.setState({phonesAdded: array});
  	}

	//Verificar si el formulario es valido
	isValidForm() {
		let isFormValid = true;
		const isSelectValid4 = this.showControlError('phone_number');
		if ( !isSelectValid4 ) {
			isFormValid = false;
		} 
		
		return isFormValid;
	}

	//desplegar errores en selceted
	showControlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if (this.state[refName] === null || this.state[refName] === "") {
		control.classList.add('error');
		res = false;
		} else{
		if(refName === "phone_number"){
			if(this.state[refName].split('_').length!==1){
			control.classList.add('error');
			return false;
			}
		}
		control.classList.remove('error');
		res = true;
		};

		return res;
	}  

	clearData(){
		this.setState({
			phonesAdded:[],
			phone_type:"CELULAR",
			phone_number:"",
			ext:"",
			showCheckboxes: false,
			errorText_phone_type:"",
			errorText_phone_number:"",
		});
	}

  	render() {
    	const { t, small_screen } = this.props;

		return (     
			<div 
				className={small_screen ? "col-xs-11 no-padding" : "col-xs-12 no-padding"}
				style={small_screen ? {marginLeft:'7%'} : {}}
			>
				{small_screen && <hr className="avatar-hr"/>}

				<div className="col-md-12 form-group no-padding">
					<div 
						className={"col-xs-12"+
							(this.state.phone_type === "OFICINA" ? " col-sm-4" : small_screen ? " col-sm-5" : " col-sm-4")
						}
					>
						<LabelForm text={t('content.generics.phones.type')} />
						<SelectForm 
							id="phone_type"
							value={this.state.phone_type}
							options={this.state.phoneTypes}
							class=" hour-input"
							handleChange={this.handleChange}
						/>
					</div>

					<div 
						className={"col-xs-12"+
							(this.state.phone_type === "OFICINA" ? " col-sm-4" : small_screen ? " col-sm-5" : " col-sm-4")
						}
					>
						<LabelForm text={t('content.offers.form.number')}  />
						<InputMaskForm 
							id="phone_number"
							value={this.state.phone_number}
							handleChange={this.handleChange}
							required={this.props.require_phone}
							mask="111-111-1111"
							placeholder=""
						/>
					</div>

					{this.state.phone_type === "OFICINA" &&
						<div className="col-xs-12 col-sm-3">
							<LabelForm text={t('content.generics.phones.ext')} />
							<InputForm 
								id="ext"
								value={this.state.ext}
								handleChange={this.handleChange}							
							/>
						</div>
					}

					<div className={"col-xs-12 "+(this.state.phone_type === "OFICINA" ? " col-sm-1" : " col-sm-2")}>
						<PlusButton 
							iconStyles={{height: 25, width: 25}}
							styles={{marginTop: '18px' }}
							disabled={this.props.disableElement}
							action={this.addPhone}
						/> 
					</div>
				</div>

				<hr className="avatar-hr"/>
				<div className="col-xs-12"> 
					<Table responsive hover style={{margin:"0px"}}>
						<thead>
							<tr>
								<th>{t('content.generics.phones.type')}</th>
								<th>{t('content.offers.form.number')}</th>
								<th>{t('content.generics.phones.ext')}</th>
								<th width={60}></th>
							</tr>
						</thead>
						<tbody>
							{this.state.phonesAdded.map( (phone, index) => (
								<tr key={index}>
									<td>{phone.type}</td>
									<td>{phone.number}</td>
									<td>{phone.extension}</td>
									<td width={60} style={{textAlign: "center",padding: "2px",}}>
										<IconButton 
											disabled={this.props.disableElement}
											title="Eliminar"
											styles={{marginRight:3}}
											action={this.removePhone}
											variables={index}
											icon={bin}
										/>
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>
		</div>
		);
  	}
}

export default translate('translations')(PhonesData);

PhonesData.defaultProps = {
	small_screen:true
}